import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useIsDuplicateInvoiceNumberApi = (invoiceId: string) => {
  const call = useCallback(
    (params?: { invoiceNumber: string }) =>
      new Promise<boolean>((resolve, reject) => {
        axiosInstance
          .get<boolean>(api.checkInvoiceNumber(invoiceId), {
            params: { invoiceNumber: params?.invoiceNumber },
          })
          .then((data) => {
            resolve(data.data);
          })
          .catch((reason) => {
            reject(reason.error);
          });
      }),
    [invoiceId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return { execute, isValidatingDuplicateInvoiceNumber: isLoading };
};

export default useIsDuplicateInvoiceNumberApi;
